import { render, staticRenderFns } from "./AppNoMenuLayout.vue?vue&type=template&id=973d3354&"
import script from "./AppNoMenuLayout.vue?vue&type=script&lang=js&"
export * from "./AppNoMenuLayout.vue?vue&type=script&lang=js&"
import style0 from "./AppNoMenuLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports